import { Fragment, useState, useEffect } from "react";

import { DataGrid } from "@mui/x-data-grid";
import Columns from "./Columns";
import PreviewBtn from "../UI/Button/Button";
import Link from "@mui/material/Link";
import Loader from "../UI/Loader/CircularLoader";

const Table = ({ rows, getData }) => {
  const findUncheckedRows = (alreadyCheckedRows, checkedRows) => {
    const uncheckedIds = [];
    if (alreadyCheckedRows !== null && alreadyCheckedRows.length > checkedRows.length) {
      //Something has been unchecked
      alreadyCheckedRows.forEach((acr) => {
        let exists = false;
        checkedRows.forEach((cr) => {
          if (acr.id === cr.id) {
            exists = true;
          }
        });

        if (!exists) {
          uncheckedIds.push(acr.id);
        }
      });
    }

    return uncheckedIds;
  };

  const internalOnlyUpdates = (checkedRows, uncheckedIds) => {
    const data = JSON.parse(localStorage.getItem("Data"));
    if (!Array.isArray(data)) return;
    const devOnly = "Dev Only: ";

    //if there are uncheckedIds
    //Remove dev only from the row
    if (uncheckedIds.length > 0) {
      data.forEach((row) => {
        uncheckedIds.forEach((uID) => {
          if (row.ReleaseNotes.includes(devOnly) && row.id === uID) {
            row.ReleaseNotes = row.ReleaseNotes.substring(devOnly.length);
          }
        });
      });
    }

    //if there are checked rows I need to add dev only to those rows
    if (checkedRows.length > 0) {
      data.forEach((row) => {
        checkedRows.forEach((cr) => {
          if (row.id === cr.id && !row.ReleaseNotes.includes(devOnly)) {
            row.ReleaseNotes = `${devOnly}${row.ReleaseNotes}`;
          }
        });
      });
    }

    //update local storage
    localStorage.removeItem("Data");
    localStorage.setItem("Data", JSON.stringify(data));
  };

  const columns = Columns.map((column) => {
    if (column.field === "IssueKey") {
      return {
        ...column,
        renderCell: (params) => (
          <Link href={`https://rcsworks.atlassian.net/browse/${params.value}`} target="_blank">
            {params.value}
          </Link>
        ),
      };
    }
    return column;
  });

  useEffect(() => {
    // Filtering the selected rows from the table
    const selectedIDs = new Set(getData.map((row) => row.id));
    const selectedRowData = rows.filter((row) => selectedIDs.has(row.id));

    // Storing the selected rows in local storage so it can be used in the preview format page.
    localStorage.setItem("Data", JSON.stringify(selectedRowData));

    return () => {
      localStorage.removeItem("Data");
    };
  }, [getData, rows]);

  return (
    <Fragment>
      <div style={{ height: 600, width: "100%", marginTop: "20px" }}>
        {getData.length ? (
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={50}
            loading={rows.length === 0}
            checkboxSelection={true}
            rowsPerPageOptions={[20, 50, 100]}
            onRowSelectionModelChange={(ids) => {
              const selectedIDs = ids.ids;
              const checkedRows = rows.filter((row) => selectedIDs.has(row.id));

              //Which rows have already have a check mark
              const alreadyCheckedRows = JSON.parse(localStorage.getItem("Checked"));

              //Clean up check marked rows
              const uncheckedIds = findUncheckedRows(alreadyCheckedRows, checkedRows);

              //Update local storage
              localStorage.setItem("Checked", JSON.stringify(checkedRows));

              //update release notes field for internalOnly rows and remove any rows that have been unchecked
              internalOnlyUpdates(checkedRows, uncheckedIds);
            }}
          />
        ) : (
          <Loader />
        )}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "20px",
        }}
      >
        <a style={{ textDecoration: "none" }} target="_blank" rel="noreferrer" href="/preview">
          {rows.length > 0 && columns.length > 0 ? <PreviewBtn disabled={false}>PREVIEW</PreviewBtn> : null}
        </a>
      </div>
    </Fragment>
  );
};

export default Table;
